import TimeZone from "@/domains/TimeZones/TimeZone";
import TimeZonesDAO from "@/domains/TimeZones/TimeZonesDAO";
import Core from "@/core/Core";

class TimeZonesService {

    static async getList(
      filters?: Parameters<typeof TimeZonesDAO.getList>[0]
    ): Promise<TimeZone[]> {
        const response = await TimeZonesDAO.getList(filters);
        return Core.utils.hydrateArray(response.data, TimeZone.fromServer);
    }

    static async get(id: string): Promise<TimeZone | null> {
        const response = await TimeZonesDAO.get(id);

        return response.data ? TimeZone.fromServer(response.data) : null;
    }
}

export default TimeZonesService;
